<h1>Login</h1>

<section id="login">
    <p>Authenticating from Ford site...</p>
</section>
